import React from 'react';
import { View } from 'react-native';

import Text from '../../../components/text/Text';
import Picker from '../../../components/picker/Picker';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

const SetupPickerField = ({
	label,
	value,
	onChange,
	options,
	hint,
	pickerWidth = 260,
	required = false,
}) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.container}>
			<Text style={styles.label}>
				{label}
				{required && <Text style={styles.required}> *</Text>}
			</Text>
			<Picker
				selectedValue={value}
				onValueChange={onChange}
				options={options}
				styles={styles.picker}
				width={pickerWidth}
			/>
			{
				hint && (
					<Text style={styles.hint}>{hint}</Text>
				)
			}
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		marginBottom: space.lg,
	},
	label: {
		...type.fieldLabel,
		color: colors.text,
		marginBottom: 6,
	},
	required: {
		color: colors.danger,
	},
	hint: {
		...type.secondary,
		color: colors.textSecondary,
		marginTop: space.xs,
	},
});

export default SetupPickerField;
